import { LAYER_RADII, posOnCircle } from "../hooks/useActiveNode";

export function RingStructure({ agentCount }: { agentCount: number }) {
  const r = LAYER_RADII;

  return (
    <svg
      className="absolute inset-0 h-full w-full"
      viewBox="0 0 100 100"
      style={{ overflow: "visible" }}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="ringGradient" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.06)" />
          <stop offset="100%" stopColor="rgba(242,129,50,0.15)" />
        </radialGradient>
      </defs>

      <circle cx="50" cy="50" r={r.agent} fill="rgba(255,255,255,0.08)" />
      <circle cx="50" cy="50" r={r.app} fill="url(#ringGradient)" />

      <circle
        cx="50"
        cy="50"
        r={(r.agent + r.app) / 2}
        fill="none"
        stroke="rgba(255,255,255,0.25)"
        strokeWidth="0.4"
        strokeDasharray="1.5 1.8"
      />
      <circle
        cx="50"
        cy="50"
        r={r.agent}
        fill="none"
        stroke="rgba(242,129,50,0.35)"
        strokeWidth="0.5"
      />
      <circle
        cx="50"
        cy="50"
        r={r.app}
        fill="none"
        stroke="rgba(255,255,255,0.22)"
        strokeWidth="0.4"
      />
      <circle
        cx="50"
        cy="50"
        r={r.b2proc}
        fill="none"
        stroke="rgba(242,129,50,0.40)"
        strokeWidth="0.4"
      />

      {Array.from({ length: agentCount }, (_, i) => {
        const p = posOnCircle(i, agentCount, r.agent);
        return (
          <line
            key={`spoke-${i}`}
            x1="50"
            y1="50"
            x2={p.x}
            y2={p.y}
            stroke="rgba(255,255,255,0.04)"
            strokeWidth="0.08"
          />
        );
      })}
    </svg>
  );
}
